import { getQueryParam } from 'utils/query'
import { getProductSystemName, PRODUCT_NAMES } from 'universal/cfs-card'
import { serverData } from 'utils/server-data'
import { isBdmcConsolidationEnabled } from '@/screens/bdmc/shared/consolidation'

const { BUSINESS_DEBIT_CARD } = PRODUCT_NAMES

export function resolveCancelFlowProductName(product?: string): string | undefined {
  const fromQuery = getQueryParam('productName')
  if (fromQuery) {
    return getProductSystemName(fromQuery) || fromQuery
  }

  if (product) {
    return getProductSystemName(product) || product
  }

  return undefined
}

export function shouldUseBdmcCancelFlow(product?: string): boolean {
  return (
    serverData?.isBdmcExperience === true &&
    resolveCancelFlowProductName(product) === BUSINESS_DEBIT_CARD &&
    isBdmcConsolidationEnabled()
  )
}

const MANAGE_CANCEL_PATH = /\/manage\/[^/?#]+\/cancel(?:[/?#]|$)/
const MANAGE_PRODUCT_CANCEL_PATH = /\/manage\/[^/?#]+\/([^/?#]+)\/cancel(?:[/?#]|$)/

/**
 * BDMC cancel can load at /cancel-card/:cardId (always FlowModal) or legacy
 * /manage/:cardId/cancel?productName=BUSINESS_DEBIT_CARD. PPDC cancel stays on
 * /manage/:cardId/cancel and must keep the v1 vx_modal wrapper for centering.
 */
export function shouldUseBdmcManageCancelFlowModal(location: string): boolean {
  const productCancelMatch = location.match(MANAGE_PRODUCT_CANCEL_PATH)
  if (productCancelMatch) {
    return shouldUseBdmcCancelFlow(productCancelMatch[1])
  }

  if (MANAGE_CANCEL_PATH.test(location)) {
    return shouldUseBdmcCancelFlow()
  }

  return false
}
